import React from "react";
import { HashRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import AppRoutes from "./routes/AppRoutes";
import { SnackbarProvider } from 'notistack';

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#04dbfa",
    },
    secondary: {
      main: "#ff9800",
    },
    background: {
      default: "#f5f5f5",
    },
  },
});

export default function App() {
  return (
    <SnackbarProvider autoHideDuration = {1000} maxSnack={3} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <AppRoutes />
        </Router>
      </ThemeProvider>
    </SnackbarProvider>
  );
}
